import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

export function Loader({ className, label }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-10', className)}>
      <Loader2 className="h-6 w-6 animate-spin text-primary-700" />
      {label && <p className="text-sm text-ink-500">{label}</p>}
    </div>
  )
}

export function EmptyState({ icon, title, description, action, className }) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-6 py-14 text-center',
        className,
      )}
    >
      {icon && (
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-50 text-primary-700 ring-1 ring-primary-100">
          {icon}
        </div>
      )}
      {title && (
        <h3 className="h-display text-xl font-semibold text-ink-900">{title}</h3>
      )}
      {description && (
        <p className="max-w-md text-pretty text-sm text-ink-500">{description}</p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}

export function SkeletonRow({ className }) {
  return (
    <div
      className={cn(
        'h-12 w-full animate-pulse rounded-xl bg-gradient-to-r from-ink-100 via-ink-50 to-ink-100',
        className,
      )}
    />
  )
}
